import * as React from "react";

const RecordingIcon = () => (
  <svg height={7} width={7} xmlns="http://www.w3.org/2000/svg">
    <circle cx={3.5} cy={3.5} fill="#de5d5d" fillRule="evenodd" r={3.5} />
  </svg>
)

export default RecordingIcon
